import { withDependencies } from '@wix/thunderbolt-ioc'
import { named } from '@wix/thunderbolt-ioc'
import type { Experiments, ImportMapProvider } from '@wix/thunderbolt-symbols'
import { ExperimentsSymbol, SiteFeatureConfigSymbol } from '@wix/thunderbolt-symbols'
import { name } from './symbols'
import type { BuilderContextProvidersSiteConfig } from './types'
import { filterContextProvidersForImportMap } from './importMapReducer'

export const BuilderContextProvidersImportMapProvider = withDependencies(
	[named(SiteFeatureConfigSymbol, name), ExperimentsSymbol],
	(siteConfig: BuilderContextProvidersSiteConfig, experiments: Experiments): ImportMapProvider => {
		const contextProvidersEnabled = Boolean(experiments['specs.thunderbolt.contextProviders'])
		return {
			provideImportMap: () => {
				if (!contextProvidersEnabled) {
					return {}
				}

				return filterContextProvidersForImportMap(siteConfig.contextProviders)
			},
		}
	}
)
